<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <div class="text-left">
                <v-btn icon v-on="on">
                    <v-icon color="primary">mdi-eye</v-icon>
                </v-btn>
            </div>
        </template>
        <v-card class="primary--text">
            <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
                {{$t('dialog_titulo')}}
                <v-spacer></v-spacer>
                <v-btn icon right @click="cerrar()" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="my-2 body-1">
                        <span class="font-weight-bold">{{$t('material')}}:&nbsp;</span>
                        {{material.codigo}}&nbsp;-&nbsp;{{material.material.nombre}}
                    </v-row>
                    <v-row class="my-2 body-1">
                        <span class="font-weight-bold">{{$t('precio')}}:&nbsp;</span>
                        {{material.costeUnitarioAcabado}}
                    </v-row>
                    <v-row v-if="material.declaracionAmbientalDermis" class="my-2 body-1">
                        <v-list two-line>
                            <v-subheader class="pl-0 font-weight-bold body-1">
                                {{$t('dap') | capitalize}}
                            </v-subheader>

                            <v-list-item v-for="(dap, index) in dapParaPrint" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{dap.nombre}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{$t('dap_val', [dap.valor, dap.unidades])}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-row>
                    <v-row v-if="material.prestacionDermis" class="my-2 body-1">
                        <v-list two-line>
                            <v-subheader class="pl-0 font-weight-bold body-1">
                                {{$t('dpres') | capitalize}}
                            </v-subheader>

                            <v-list-item v-for="(pres, index) in presParaPrint" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{$t('pres_indi', [pres.indicador, pres.norma])}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{$t('pres_val', [pres.valor, pres.unidades])}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="error" text depressed @click="dialog = false">
                    {{$t('cerrar') | capitalize}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {HttpHelper} from "../../../comunes/helpers/HttpHelper";

    export default {
        name: "BtnVerMaterial",
        props: {
            material: {type: Object, required: true},
        },
        data: () => ({
            dialog: false,
            prestacionales: [],
            impactos: []
        }),
        computed: {
            dapParaPrint() {
                if (!this.material) return [];
                if (!this.material.declaracionAmbientalDermis) return [];
                if (this.impactos.length < 1) return [];

                let paraPrint = [];

                Object.keys(this.material.declaracionAmbientalDermis).forEach((key) => {
                    if (key !== "id" && this.material.declaracionAmbientalDermis[key] != null) {
                        let impacto = null;
                        this.impactos.forEach((impactoB) => {
                            if (impactoB.codigo.toLowerCase() === key.toLowerCase()) {
                                impacto = impactoB;
                            }
                        });

                        if (impacto != null) {
                            paraPrint.push({
                                valor: this.material.declaracionAmbientalDermis[key],
                                nombre: impacto.nombre,
                                unidades: impacto.unidades,
                            });
                        }

                    }
                });

                return paraPrint;
            },
            presParaPrint() {
                if (this.material.prestacionDermis == null || this.prestacionales.length < 1) return [];
                let paraPrint = [];
                Object.keys(this.material.prestacionDermis.parametros).forEach((codigoIndicador) => {
                    let indicador = null;
                    this.prestacionales.forEach((indicadorB) => {
                        if (indicadorB.indicador.codigo == codigoIndicador) indicador = indicadorB;
                    });
                    if (indicador != null) {
                        let valor = this.material.prestacionDermis.parametros[codigoIndicador];
                        let paraPrintValor = this.paraPrintPrestacional(valor, indicador);
                        paraPrintValor.indicador = indicador.indicador.nombre;
                        paraPrint.push(paraPrintValor);
                    }
                });

                return paraPrint;
            }
        },
        watch: {
            dialog: function (val) {
                if (val) this.init();
            }
        },
        methods: {
            init() {
                this.cargarPrestacionales();
                this.cargarImpactos();
            },
            cerrar() {
                this.dialog = false;
            },
            paraPrintPrestacional(valor, indicador) {
                valor = valor.trim();

                let clase = null;
                indicador.opciones.forEach((opcion) => {
                    if (opcion.valor === valor) {
                        clase = {
                            valor: valor,
                            norma: opcion.norma,
                            unidades: opcion.unidades
                        };
                    }
                });

                if (clase != null) return clase;

                return {
                    valor: valor,
                    norma: indicador.rangoDatos.norma,
                    unidades: indicador.rangoDatos.unidades
                };
            },
            cargarImpactos() {
                this.impactos = [];
                if (this.material.declaracionAmbientalDermis == null) return;

                HttpHelper.get(`impactos`).then(data => {
                    this.impactos = data;
                });
            },
            cargarPrestacionales() {
                this.prestacionales = [];
                if (this.material.material == null || this.material.prestacionDermis == null) return;

                HttpHelper.get(`material-personalizado/indicadores-prestacionales/${this.material.material.codigo}`)
                    .then(data => {
                        this.prestacionales = data;
                    });
            }
        },
    }
</script>

<style scoped>
    .mayus {
        text-transform: uppercase;
    }
</style>
<i18n>
    {
    "es": {
    "dialog_titulo": "Detalles del material",
    "material": "Material",
    "precio": "Precio",
    "dap": "Declaración ambiental:",
    "dpres": "características técnicas:",
    "dap_indi": "{0} (<span class='mayus'>{1}</span>)",
    "dap_val": "{0} ({1})",
    "pres_indi": "{0}, norma: {1}",
    "pres_val": "{0} ({1})"
    }
    }
</i18n>
